var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"hide-details":"","outlined":"","type":"number","step":_vm.property.step},on:{"blur":function($event){return _vm.onBlur($event.target.value)}},model:{value:(_vm.property.value),callback:function ($$v) {_vm.$set(_vm.property, "value", $$v)},expression:"property.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }